import { OauthProvider } from '../components/Constants';

const providerPatterns: Array<{
  patterns: string[];
  provider: OauthProvider;
}> = [
  {
    patterns: ['google'],
    provider: OauthProvider.GOOGLE,
  },
  {
    patterns: ['apple'],
    provider: OauthProvider.APPLE,
  },
  {
    patterns: ['facebook'],
    provider: OauthProvider.FACEBOOK,
  },
  {
    patterns: ['azure', 'microsoft'],
    provider: OauthProvider.MICROSOFT,
  },
];

const normalizeMessage = (message: string) => {
  return message.trim().replace(/\s+/g, ' ');
};

const getFlattenedMessages = (
  error: string | PreloadedFlashError
): string[] => {
  if (typeof error === 'string') return [error];

  return Array.isArray(error.messages) ? error.messages : [error.messages];
};

export const getPreloadedErrorMessages = (errors: typeof preloadedErrors) => {
  if (!errors) return [];

  const messages =
    typeof errors === 'string'
      ? [errors]
      : errors.flatMap(getFlattenedMessages);

  return messages
    .map((message) => normalizeMessage(message))
    .filter((message) => message !== '');
};

export const getProviderFromMessage = (message: string) => {
  return providerPatterns.find(({ patterns }) => {
    return patterns.some((pattern) => message.includes(pattern));
  })?.provider;
};

export const isProviderLinkedOauthAccountMessage = (message: string) => {
  return /\balready a .+ account associated with\b/.test(message);
};

export const isAccountExistsMessage = (message: string) => {
  return (
    message.includes('account already exists') ||
    message.includes('already an account') ||
    message.includes('already registered')
  );
};

export const isConnectivityMessage = (message: string) => {
  return (
    message.includes("can't connect") ||
    message.includes('cannot connect') ||
    message.includes('unable to connect') ||
    message.includes('check your connection') ||
    message.includes('try again later') ||
    message.includes('try again in a minute') ||
    message.includes('try a different method') ||
    message.includes('come back shortly')
  );
};
